import { useState, useEffect, useContext } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { Autocomplete } from "@mui/material";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import FormField from "layouts/applications/wizard/components/FormField";
import { useNavigate } from "react-router-dom";

import CrudService from "services/cruds-service";
import { MODULE_MASTER } from "utils/constant";
import ModalEntityAddressItemSelect from "cruds/device-management/select-entity";
import { toast } from 'react-toastify';
import AddIdentifier from "../add-identifier";
import Thresholds from "../thresolds";
import SubscriptionDevice from "../subscription_device";
import ModalEntitySelect from "cruds/device-management/select-entity-main";
import { AuthContext } from "context";
import { AbilityContext } from "Can";
import { useAbility } from "@casl/react";

const NewDevice = () => {
  const navigate = useNavigate();
  const ability = useAbility(AbilityContext)

  if (!ability.can('create', 'devices')) {
    navigate('/device-list')
    return
  }
  const [name, setName] = useState({
    text: "",
    error: false,
    textError: "",
  });

  const [deviceType, setDeviceType] = useState([]);
  const [deviceTypes, setDeviceTypes] = useState([]);
  const [entityAddressItem, setEntityAddressItem] = useState([]);
  const [entityAddressItems, setEntityAddressItems] = useState([]);
  const [entityItem, setEntityItem] = useState([]);
  const [statusType, setStatusType] = useState([]);
  const [statusDevice, setStatusDevice] = useState([]);
  const [brand, setBrand] = useState([]);
  const [brands, setBrands] = useState([]);
  const [obrands, setOBrands] = useState([]);
  const [model, setModel] = useState({});
  const [models, setModels] = useState([]);
  const [omodels, setOModels] = useState([]);
  const [typebrand, setTypeBrand] = useState([]);
  const [brandmodel, setBrandModel] = useState([]);
  const [deviceConfig, setDeviceConfig] = useState([])
  const [externalDetect, setDetect] = useState(false)
  const [identifer, setIdentifier] = useState([])
  const [identiferItem, setIdentifierItem] = useState([])
  const [selectedThresholds, setSelectedThresholds] = useState([]);
  const [requiredThresholds, setRequiredThresholds] = useState([])
  const [deviceModes, setDeviceModes] = useState([])
  const [modes, setModes] = useState({})
  const [subscriptionPlanList, setSubscriptionPlanList] = useState([])
  const [formData, setFormData] = useState({
    auto_renew: 1,
    cancelled_at: null,
    device_id: null,
    end_date: null,
    plan_id: null,
    price_override: null,
    start_date: null,
    status_id: null,
    subscription_source: 'admin'
  });
  const authContext = useContext(AuthContext)
  const [entityList, setEntityList] = useState([])

  useEffect(() => {
    (async () => {
      try {
        const response = await CrudService.getDeviceTypes();
        setDeviceTypes(response.data);
      } catch (err) {
        console.error(err);
        return null;
      }
    })();

    (async () => {
      try {
        const response = await CrudService.getStatusTypes(MODULE_MASTER.DEVICES);
        setStatusDevice(response.data);
        setStatusType(response.default_id);
      } catch (err) {
        console.error(err);
        return null;
      }
    })();

    (async () => {
      try {
        const response = await CrudService.getEntityAddressItems();
        const transformedResponse = response.map(item => ({
          ...item,
          id: item.address_item_id // Assuming address_item_id is the correct field name in your response
        }));

        setEntityAddressItems(transformedResponse);
      } catch (err) {
        console.error(err);
        return null;
      }
    })();

    (async () => {
      try {
        const response = await CrudService.getDeviceBrands();
        setOBrands(response.data);
      } catch (err) {
        console.error(err);
        return null;
      }
    })();

    (async () => {
      try {
        const response = await CrudService.getDeviceModels();
        setOModels(response.data);
      } catch (err) {
        console.error(err);
        return null;
      }
    })();

    (async () => {
      try {
        const response = await CrudService.getDeviceTypeBrand();
        setTypeBrand(response.data);
      } catch (err) {
        console.error(err);
        return null;
      }
    })();

    (async () => {
      try {
        const response = await CrudService.getDeviceBrandModel();
        setBrandModel(response.data);
      } catch (err) {
        console.error(err);
        return null;
      }
    })();

    (async () => {
      try {
        const response = await CrudService.getDeviceModelConfig();
        setDeviceConfig(response.data);
      } catch (err) {
        console.error(err);
        return null;
      }
    })();

    (async () => {
      try {
        if (authContext.userDetail.role_id === 1) {
          const entityResponse = await CrudService.getEntities()
          setEntityList(entityResponse.data)
        }
      } catch (err) {
        console.error(err);
        return null;
      }
    })();

    (async () => {
      try {
        const response = await CrudService.getDeviceModes();
        if (response.success) {
          setDeviceModes(response.data)
          setModes(response.data.filter(e => e.mode_id === 3)[0])
        }
      } catch (err) {
        console.error(err);
        return null;
      }
    })();

    (async () => {
      try {
        const response = await CrudService.getSubscriptionPlanList();
        setSubscriptionPlanList(response.data);
      } catch (err) {
        console.error(err);
        return null;
      }
    })();

  }, []);

  const changeNameHandler = (e) => {
    setName({ ...name, text: e.target.value });
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    if (externalDetect && identiferItem.filter((e) => e.error === true || e.text == '').length) {
      toast.error('Identifier required')
      return
    }

    let hasValidationError = false;
    const updatedSelectedThresholds = [...selectedThresholds];
    let list_of_required;
    // let mapped = requiredThresholds.map((e) => e.id)
    let thresholdMapped = updatedSelectedThresholds.map((e) => e.id)
    let hasRequiredError = requiredThresholds.every((e) => {
      if (thresholdMapped.includes(e.id)) {
        return true
      }
      list_of_required = e
      return false
    })
    if (!hasRequiredError) {
      toast.info(`Parameter ${list_of_required.DeviceParameter.parameter_name} is required!`)
      return
    }
    updatedSelectedThresholds.forEach(updatedSelectedThreshold => {
      const validError = validateInput(updatedSelectedThreshold?.field_type_id, updatedSelectedThreshold?.threshold_value)
      updatedSelectedThreshold.validationError = validError;
      if (validError) {
        hasValidationError = validError;
        return;
      }
    })

    setSelectedThresholds(updatedSelectedThresholds);
    // return

    if (hasValidationError) {
      return;
    }

    const device = {
      data: {
        type: "devices",
        attributes: {
          name: name.text,
          deviceType: deviceType?.attributes,
          statusType: statusType?.attributes,
          entityAddressItem: entityAddressItem[0],
          brand: brand?.attributes,
          model: model?.attributes,
          deviceParameterThresholds: selectedThresholds,
          mode_id: modes.mode_id,
          entity_id: entityItem.length > 0 ? entityItem[0]?.id : null
        }
      },
    };

    if (externalDetect) {
      device.data.attributes.identifier = identiferItem
      device.data.attributes.isExternal = true
      try {
        let payload = identiferItem.filter((e) => e.is_mapping_key)
        if (!payload.length) {
          toast.info('Is mapping key not found in indetifier', { autoClose: true })
          return
        }
        let resp = await CrudService.checkImeiExist({ identiferItem: payload[0] });

        if (resp.exist) {
          toast.info(resp.msg, { autoClose: true })
          return;
        }

        let createDeviceResp = await createDeviceHandler(device)
        if (createDeviceResp) {
          formData.device_id = createDeviceResp.id
          if (formData.plan_id) {
            await createSubscriptionHandler(formData)
          } else {
            navigate("/devices", {
              state: { value: true, text: "The device was successfully created" },
            });
          }
        }

      } catch (err) {
        console.error(err);
        toast.error(err.errors[0].detail ?? 'Something went wrong')
      }
    } else {
      try {
        let resp = await createDeviceHandler(device)
        if (resp) {
          formData.device_id = resp.id
          if (formData.plan_id) {
            await createSubscriptionHandler(formData)
          } else {
            navigate("/devices", {
              state: { value: true, text: "The device was successfully created" },
            });
          }
        }
      } catch (error) {
        console.error(error);
        toast.error(error.errors[0].detail ?? 'Something went wrong')
      }
    }

  };

  const createDeviceHandler = async (device) => {
    try {
      let resp = await CrudService.createDevice(device);

      return resp.data
      // navigate("/devices", {
      //   state: { value: true, text: "The device was successfully created" },
      // });
    } catch (err) {
      console.error(err);
      toast.error(err.errors[0].detail)
    }
  }

  const createSubscriptionHandler = async (payload) => {
    try {
      let resp = await CrudService.createSubscription(payload);
      if (resp.success) {
        navigate("/devices", {
          state: { value: true, text: "The device was successfully created" },
        });
      }
    } catch (err) {
      console.error(err);
      toast.error(err.error)
    }
  }

  const deviceConfigHandler = async (e) => {
    setSelectedThresholds([])
    setIdentifierItem([])
    setDetect(false)
    let checkModelExist = deviceConfig.filter(({ model_id }) => model_id === e.id);
    if (checkModelExist.length) {
      setIdentifier(checkModelExist[0].DeviceConfigIdentifierAssociations)
      checkModelExist[0].DeviceConfigIdentifierAssociations.map((val) => setIdentifierItem((e) => [...e, {
        text: '',
        error: false,
        textError: '',
        regex: val.DeviceIdentifierType.validation_rule,
        association_id: val.association_id,
        name: val.DeviceIdentifierType.identifier_type_name,
        ...val
      }]))
      setDetect(true)
    } else {
      setDetect(false)
      setIdentifierItem([])
    }
  }
  const validateInput = (field_type_id, value) => {
    switch (field_type_id) {
      case 2:
        if (!Number.isInteger(parseInt(value, 10))) {
          return 'Value must be an integer';
        }
        break;
      case 3:
        if (!/^-?\d+\.\d+$/.test(value)) {
          return 'Value must be a float';
        }
        break;
      case 4:
        if (!['true', 'false', '1', '0'].includes(value.toLowerCase())) {
          return 'Value must be a boolean (true/false or 1/0)';
        }
        break;
      case 5:
        if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
          return 'Value must be a valid date (YYYY-MM-DD)';
        }
        break;
      case 6:
        if (!/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value)) {
          return 'Value must be a valid datetime (YYYY-MM-DD HH:MM:SS)';
        }
        break;
      case 7:
        if (!/^\d{10}$/.test(value)) {
          return 'Value must be a valid timestamp (10 digits)';
        }
        break;
      case 8:
        if (value.length > 255) {
          return 'Value must be less than or equal to 255 characters';
        }
        break;
      case 9:
        // Add specific validation logic for list type
        if (!Array.isArray(value)) {
          return 'Value must be list';
        }
        break;
      default:
        // No specific validation for other field types
        return null;
    }

    // If validation passes
    return null;
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {/* <ToastContainer /> */}
      <MDBox mt={5} mb={9}>
        <Grid container justifyContent="center">
          <Grid item xs={12} lg={8}>
            <MDBox mt={6} mb={8} textAlign="center">
              <MDBox mb={1}>
                <MDTypography variant="h3" fontWeight="bold">
                  Add New Device
                </MDTypography>
              </MDBox>
              <MDTypography variant="h5" fontWeight="regular" color="secondary">
                This information will describe more about the Device.
              </MDTypography>
            </MDBox>
            <Card>
              <MDBox component="form" method="POST" onSubmit={submitHandler}>
                <MDBox display="flex" flexDirection="column" px={3} my={2}>
                  <MDBox py={1}>
                    <FormField
                      type="text"
                      label="Device Name"
                      name="name"
                      value={name.text || ""}
                      onChange={changeNameHandler}
                      error={name.error}
                      required
                    />
                    {name.error && (
                      <MDTypography variant="caption" color="error" fontWeight="light">
                        {name.textError}
                      </MDTypography>
                    )}
                  </MDBox>
                  <Autocomplete
                    defaultValue=""
                    sx={{ paddingBottom: '10px' }}
                    options={deviceTypes}
                    getOptionLabel={(option) => (option.attributes ? option.attributes.type_name : "")}
                    value={deviceType ?? ""}
                    onChange={(event, newdeviceType) => {
                      setDeviceType(newdeviceType);
                      if (newdeviceType) {
                        const filtered = typebrand
                          .filter((assoc) => assoc.type_id === newdeviceType?.attributes?.device_type_id)
                          .map((assoc) => obrands.find((brand) => brand?.attributes?.brand_id === assoc?.brand_id));
                        setBrands(filtered);
                        setBrand([]);
                        setModel({});
                      } else {
                        // Reset filtered brands if no type is selected
                        setBrands([]);
                        setBrand([]);
                        setModel({});
                      }
                    }}
                    renderInput={(params) => (
                      <FormField {...params} label="Device Type" InputLabelProps={{ shrink: true }} required />
                    )}
                  />

                  <Autocomplete
                    defaultValue=""
                    sx={{ paddingBottom: '10px' }}
                    options={brands}
                    getOptionLabel={(option) => (option.attributes ? option?.attributes?.brand_name : "")}
                    value={brand ?? ""}
                    onChange={(event, newBrand) => {
                      setBrand(newBrand);
                      if (newBrand) {
                        const filtered = brandmodel
                          .filter((assoc) => assoc.brand_id === newBrand?.attributes?.brand_id)
                          .map((assoc) => omodels.find((model) => model?.attributes?.model_id === assoc?.model_id));
                        setModels(filtered);
                        setModel({})
                      } else {
                        // Reset filtered brands if no type is selected
                        setModels([]);
                        setModel({})
                      }
                    }}
                    renderInput={(params) => (
                      <FormField {...params} label="Device Brand" InputLabelProps={{ shrink: true }} required />
                    )}
                  />

                  <Autocomplete
                    defaultValue=""
                    sx={{ paddingBottom: '10px' }}
                    options={models}
                    getOptionLabel={(option) => (option.attributes ? option.attributes?.model_name : "")}
                    value={model ?? ""}
                    onChange={(event, newModel) => {
                      deviceConfigHandler(newModel)
                      setModel(newModel);
                    }}
                    renderInput={(params) => (
                      <FormField {...params} label="Device Model" InputLabelProps={{ shrink: true }} required />
                    )}
                  />
                  {
                    deviceModes.length ?
                      <Autocomplete
                        defaultValue=""
                        sx={{ paddingBottom: '10px' }}
                        options={deviceModes}
                        getOptionLabel={(option) => (option ? option.mode_name : '')}
                        value={modes ?? ""}
                        disableClearable
                        onChange={(event, newStatus) => {
                          setModes(newStatus);
                        }}
                        renderInput={(params) => (
                          <FormField {...params} label="Mode" InputLabelProps={{ shrink: true }} />
                        )}
                      /> : ''
                  }

                  <Autocomplete
                    defaultValue=""
                    options={statusDevice}
                    getOptionLabel={(option) => (option.attributes ? option.attributes?.StatusType.status_name : "")}
                    value={statusType ?? ""}
                    disableClearable
                    onChange={(event, newStatus) => {
                      setStatusType(newStatus);
                    }}
                    renderInput={(params) => (
                      <FormField {...params} label="Status" InputLabelProps={{ shrink: true }} />
                    )}
                  />
                  {
                    authContext.userDetail.role_id === 1 ?
                      <ModalEntitySelect entityList={entityList} entityItem={entityItem} setEntityItem={setEntityItem} /> : ''
                  }
                  <ModalEntityAddressItemSelect entityAddressItems={entityAddressItems} entityAddressItem={entityAddressItem} setEntityAddressItem={setEntityAddressItem} />
                  {
                    model?.id &&
                    <Thresholds selectedThresholds={selectedThresholds} setSelectedThresholds={setSelectedThresholds} type="create" model_id={model?.id} setRequiredThresholds={setRequiredThresholds} />
                  }

                  {externalDetect ?
                    <AddIdentifier identifer={identifer} identiferItem={identiferItem} setIdentifierItem={setIdentifierItem} onSave={() => {}} /> : <></>}
                  <SubscriptionDevice formData={formData} setFormData={setFormData} subscriptionPlanList={subscriptionPlanList} />
                  <MDBox ml="auto" mt={4} mb={2} display="flex" justifyContent="flex-end">
                    <MDBox mx={2}>
                      <MDButton
                        variant="gradient"
                        color="dark"
                        size="small"
                        px={2}
                        mx={2}
                        onClick={() =>
                          navigate("/devices", {
                            state: { value: false, text: "" },
                          })
                        }
                      >
                        Back
                      </MDButton>
                    </MDBox>
                    <MDButton variant="gradient" color="dark" size="small" type="submit">
                      Save
                    </MDButton>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default NewDevice;
